<template lang="pug">
.addManager.container
    h3.addManager__title.col-md-12 新增使用者
    AddManagerInputsTable.addManager__inputsTable(:class="'col-md-6'")
    AblilityGroupTable.addManager__abilityGroupTable(:class="'col-md-6'")
</template>
<script>
import AddManagerInputsTable from '@/pages/manager/AddManagerInputsTable'
import AblilityGroupTable from '@/pages/manager/AblilityGroupTable'

export default {
  name: 'AddManager',
  components: {
    AddManagerInputsTable,
    AblilityGroupTable,
  },
}
</script>
<style lang="scss" scoped>
.addManager {
  padding-left: 70px;
  background: #f7f7f7;

  &__title {
    padding-top: 10px;
    padding-bottom: 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/AddManagerNew.vue